import { SEASON } from 'a/hub/data/constants';
import StepTypes from 'root/activities/hub/data/StepTypes';
import { aquaAxiosWithCreds, adjustLevels, getLevelsMasteredFromSkillLevel } from 'lib/utilityFunctions';
import { RECOMMENDED_SKILLS_URL, CONTENT_SERVICE_URL } from './endpoints';
import gameIds from '../hub/data/GameIds';
import { handleAuthFailure } from './apiErrors';

const fetchProfileDataStart = () => ({
  gameId: gameIds.METAGAME,
  type: 'FETCH_PROFILE_FOR_EOQ_START',
  payload: {},
});

const isEreader = gameId => gameId.includes('ereader');

async function loadGames({ skillMap, studentId, season, product }) {
  const { data } = await aquaAxiosWithCreds(
    `${RECOMMENDED_SKILLS_URL}/profile?userId=${studentId}&skillMap=${skillMap}`,
  );

  if (data.Data.NoRecommendationsAvailable) {
    return [];
  }

  const userSkills = data.Data.RecommendedSkills;
  const skillLevels = data.Data.SkillLevels.filter(skillLevel => skillLevel.Source === 'level_result');
  const skills = userSkills.map(skill => skill.Skill).join(',');
  const contentSets = await aquaAxiosWithCreds(
    `${CONTENT_SERVICE_URL}/gameContentSets?skills=${skills}&skillMap=${skillMap}`,
  );
  if (!contentSets.data.GameContentSets.length) {
    return [];
  }

  const gamesToPlay = [];
  contentSets.data.GameContentSets.forEach((content) => {
    const step = { ...content.Content[0], skillId: content.Skill };
    // TO-DO remove excluding ereader from Season 3 when issue is fixed
    if (!(season === SEASON.GRADE_4_5 && isEreader(step.GameId))) {
      gamesToPlay.push({
        game: step.GameId,
        levels: adjustLevels(step.Levels),
        levelsMastered: getLevelsMasteredFromSkillLevel(step.skillId, step.Levels, skillLevels),
        type: isEreader(step.GameId) ? StepTypes.EREADER : StepTypes.GAME,
        friendlyName: isEreader(step.GameId) ? step.GameName : '',
        skillId: step.skillId,
        product,
      });
    }
  });
  return gamesToPlay.slice(0, 3); // only return first 3 games
}

export default function getGamesForChallengeQuest() {
  return async (dispatch, getState) => {
    const {
      persistStateReducer: { skillMap, studentId, season },
      appSessionReducer: { product },
    } = getState();
    dispatch(fetchProfileDataStart());
    try {
      return await loadGames({ skillMap, studentId, season, product });
    } catch (error) {
      handleAuthFailure(error);
      throw error;
    }
  };
}
